export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5377.ca223624.jpg";